import { DASHBOARD_PREFIX } from '@/features/Dashboard/constants/const';

import type { NavigateFunction } from 'react-router';

type HomepageTarget = {
  path: string;
  replace?: boolean;
};

export const shouldDelayNavigation = (
  isMarketsListSuccess: boolean,
  isUserConfigSuccess: boolean,
  marketsListLength: number,
  isPersonalizationEnabled: boolean | undefined
) => {
  return (
    !isMarketsListSuccess ||
    !isUserConfigSuccess ||
    marketsListLength < 1 ||
    isPersonalizationEnabled === undefined
  );
};

export const resolveHomepageTarget = (
  homepage: string | undefined,
  isPersonalizationEnabled: boolean,
  isMarketValid: (marketId: string) => boolean
): HomepageTarget | null => {
  if (!isPersonalizationEnabled || !homepage) return null;

  if (homepage === 'my-dashboard') {
    return { path: '/dashboard' };
  }

  if (homepage.startsWith(DASHBOARD_PREFIX)) {
    const dashboardId = homepage.replace(DASHBOARD_PREFIX, '');
    return { path: `/dashboard/${encodeURIComponent(dashboardId)}` };
  }

  if (isMarketValid(homepage)) {
    return { path: `/markets/${homepage}`, replace: true };
  }

  return null;
};

export const navigateToTarget = (navigate: NavigateFunction, target: HomepageTarget) => {
  if (target.replace) {
    navigate(target.path, { replace: true });
    return;
  }
  navigate(target.path);
};

export const getFallbackMarketId = (
  defaultMarketId: string | undefined,
  marketsList: Array<{ marketId: string }>,
  isMarketValid: (marketId: string) => boolean
) => {
  if (defaultMarketId && isMarketValid(defaultMarketId)) {
    return defaultMarketId;
  }
  return marketsList[0]?.marketId;
};
